export default function ReminderDetails() {
  return <>Reminder Details</>;
}
